import { render, staticRenderFns } from "./create-brithday.vue?vue&type=template&id=93985628&scoped=true"
import script from "./create-brithday.vue?vue&type=script&lang=js"
export * from "./create-brithday.vue?vue&type=script&lang=js"
import style0 from "./create-brithday.vue?vue&type=style&index=0&id=93985628&prod&lang=scss&scoped=true"
import style1 from "./create-brithday.vue?vue&type=style&index=1&id=93985628&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93985628",
  null
  
)

export default component.exports